import React, { useState } from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AuthPageLayout from "../../components/layout/AuthPageLayout";
import { images } from "../../assets";
import { TextInput } from "../../components/TextInput";
import { treatmentPlanService } from "../../services/treatmentPlanService";
import {
  RejectedContainer,
  RejectedIcon,
  RejectedTitle,
  RejectedSubtitle,
  CommentContainer,
  RejectedActions,
  SuccessMessage,
} from "./TreatmentPlanRejectedPage.styled";

const TreatmentPlanRejectedPage: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [comment, setComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isCommentSent, setIsCommentSent] = useState(false);

  const handleSubmitComment = async () => {
    if (!token || !comment.trim()) return;

    try {
      setIsSubmitting(true);
      await treatmentPlanService.rejectByPatient(token, comment);
      setIsCommentSent(true);
    } catch (error) {
      console.error("Error submitting comment:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthPageLayout contentWidth={720}>
      <RejectedContainer>
        <RejectedIcon>
          <Box
            component="img"
            src={images.reject}
            alt={t("treatmentPlanRejected.iconAlt")}
            sx={{ 
              width: { xs: "150px", sm: "200px" }, 
              height: "auto" 
            }}
          />
        </RejectedIcon>

        <RejectedTitle>
          {t("treatmentPlanRejected.title")}
        </RejectedTitle>

        <RejectedSubtitle>
          {t("treatmentPlanRejected.subtitle")}
        </RejectedSubtitle>

        {!isCommentSent && token && (
          <>
            <CommentContainer>
              <TextInput
                label={t("treatmentPlanRejected.commentLabel")}
                placeholder={t("treatmentPlanRejected.commentPlaceholder")}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                multiline
                rows={4}
                height={120}
                fullWidth
              />
            </CommentContainer>

            <RejectedActions>
              <Button
                variant="contained"
                onClick={handleSubmitComment}
                disabled={isSubmitting || !comment.trim()}
                fullWidth
                sx={{
                  minWidth: { xs: "100%", sm: 200 },
                }}
              >
                {isSubmitting ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  t("treatmentPlanRejected.submitButton")
                )}
              </Button>
            </RejectedActions>
          </>
        )}

        {isCommentSent && (
          <SuccessMessage>
            {t("treatmentPlanRejected.successMessage")}
          </SuccessMessage>
        )}
      </RejectedContainer>
    </AuthPageLayout>
  );
};

export default TreatmentPlanRejectedPage;

